exports.__objectFromAsync = require('../$to-object/async-to-object.js').__asyncToObject;
exports.objectFromAsync = require('../$to-object/async-to-object.js').asyncToObject;